import Breadcrumb from "../../Component/Breadcrumb";

function Curricular() {
  return (
    <>
      <Breadcrumb>Students / Co-Curricular Activities</Breadcrumb>
      <div className="innersec admission_sec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Co-Curricular Activities</h1>
          </div>
          <p>
            The school organizes various cultural and literary programmes (Inter
            House Competitions) every year to bring out the talents of the
            students and prepare them for different Inter School Competitions.
            Besides this, the school promotes outdoor and social activities for
            which educational tours are arranged to various places of historical
            and cultural importance in order to develop children's social
            confidence, empathy, constructive skills, aesthetic awareness,
            communicative skills and sportsmanship.
          </p>
        </div>
      </div>
    </>
  );
}
export default Curricular;
